import type { ReactNode } from 'react';

import type { SectionDividerItem } from './useCourse';
import styles from './SectionDivider.module.css';

interface SectionDividerProps {
  // Instructor actions (the kebab). Absent for students and in edit mode, where
  // the drag handle owns the row instead.
  actions?: ReactNode;
  dragHandle?: ReactNode;
  item: SectionDividerItem;
}

export function SectionDivider({ actions, dragHandle, item }: SectionDividerProps) {
  return (
    <div
      className={styles.divider}
      data-has-actions={actions ? 'true' : 'false'}
      data-has-drag-handle={dragHandle ? 'true' : 'false'}
    >
      {dragHandle ? <div className={styles.dragSlot}>{dragHandle}</div> : null}
      <div className={styles.content}>
        <span aria-hidden="true" className={styles.rule} />
        <div className={styles.label}>{item.title}</div>
        <span aria-hidden="true" className={styles.rule} />
      </div>
      {actions ? <div className={styles.actionSlot}>{actions}</div> : null}
    </div>
  );
}
